module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_60yd_n.d0ec171e.csv";